<template>
  <div ref="text-to-truncate"
       class="text-to-truncate">
    <slot />
    <div v-if="isTruncate"
         :class="{'tAc': align === 'center', 'tAr': align === 'right'}">
      <p v-if="viewMore"
         class="text-truncate-arrow text-truncate-view-more"
         @click="changeToFullText">{{ $t('textTruncate.verMas') }}</p>
      <p v-if="viewLess"
         class="text-truncate-arrow text-truncate-view-less"
         @click="changeToSmallText">{{ $t('textTruncate.verMenos') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: 'left'
    }
  },
  data: () => ({
    fullText: '',
    smallText: '',
    isTruncate: false,
    viewMore: true,
    viewLess: false
  }),
  mounted() {
    if (
      this.$el.getElementsByTagName('p')[0] &&
      this.$el.getElementsByTagName('p')[0].textContent
    ) {
      this.fullText = this.$el.getElementsByTagName('p')[0].textContent
      this.smallText = this.truncateText(this.fullText)
      this.$el.getElementsByTagName('p')[0].innerText = this.smallText
    }
  },
  methods: {
    truncateText: function(fullText) {
      var truncateText = ''
      if (fullText) {
        if (window.innerWidth > 1024) {
          this.isTruncate = fullText.length > 800
          truncateText =
            fullText.length > 800
              ? fullText.substring(0, 800) + '...'
              : fullText.substring(0, 800)
        } else if (window.innerWidth > 768) {
          this.isTruncate = fullText.length > 400
          truncateText =
            fullText.length > 400
              ? fullText.substring(0, 400) + '...'
              : fullText.substring(0, 400)
        } else {
          this.isTruncate = fullText.length > 500
          truncateText =
            fullText.length > 500
              ? fullText.substring(0, 500) + '...'
              : fullText.substring(0, 500)
        }
        return truncateText
      }
      return fullText
    },
    changeToFullText: function(e) {
      this.$el.getElementsByTagName('p')[0].innerText = this.fullText
      this.viewMore = false
      this.viewLess = true
    },
    changeToSmallText: function(e) {
      this.$el.getElementsByTagName('p')[0].innerText = this.smallText
      this.viewMore = true
      this.viewLess = false
    }
  }
}
</script>

<style lang="scss">
@import './text-truncate.sass'
</style>
